var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"geographic-zone"},[_c('div',{staticClass:"begin p-6 rounded shadow bg-white"},[_c('div',{staticClass:"title text-black pb-4 border-b"},[_vm._v(" "+_vm._s(_vm.$t('geographicAreas'))+" ")]),_c('br'),_c('div',{staticClass:"line"},[_c('div',{ref:"chartdiv",staticClass:"hello",attrs:{"id":"chartdiv"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }